// Primavera P6 round trip (back/routes/p6.js).
import { url, tokenRef } from "api";

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem(tokenRef)}` });

export async function importXer(projectId, file, { review = false } = {}) {
  const body = new FormData();
  body.append("file", file);
  const res = await fetch(`${url}/projects/${projectId}/p6/import${review ? "?review=1" : ""}`, {
    method: "POST", headers: auth(), body,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.err || "P6 import failed");
  return data;
}

// The export needs the auth header, so it cannot be a plain link: fetch
// it, then hand the browser a blob to save.
export async function downloadXer(projectId, filename = "schedule.xer") {
  const res = await fetch(`${url}/projects/${projectId}/p6/export.xer`, { headers: auth() });
  if (!res.ok) {
    let err = "P6 export failed";
    try { err = (await res.json()).err || err; } catch (e) { /* not json */ }
    throw new Error(err);
  }
  const blob = await res.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  // The server names the file with the project prefix ("SPX-…"); ours is the fallback.
  a.download = (((res.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/) || [])[1]) || filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoking immediately can cancel the save in some browsers.
  setTimeout(() => URL.revokeObjectURL(href), 10000);
}
